import { Button, DatePicker, Form, Modal, Select } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../../utils/eventEmitter';
import dayjs from 'dayjs';
import usePosSalesUpdateAPI from '../apis/posSalesUpdateAPI';


const columns = [
  {
    title: 'Point of Sale',
    dataIndex: 'pos_id',
    key: 'pos_id',
  }
]


const MyFooter = ({ handleSaveNew, handleSaveClose, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSaveNew} type='text'>PRINT</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};



const SalesDetailsModal = ({data}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleCancel = () => setIsModalOpen(false);
  
  const { printSalesUpdate } = usePosSalesUpdateAPI();


  const handlePrint = async () => {
    try {
      const results = await printSalesUpdate();
      console.log(results);
    }catch (err) {
      console.log(err)
    }
  };


  
  useEffect(() => {
    EventEmitter.subscribe('opensalesdetails', info => {
      setIsModalOpen(true);
    });
    return () => EventEmitter.unsubscribe('opensalesdetails');
  },[])

  useEffect(() => {
    if (isModalOpen) {
      form.setFieldValue('pos', data.map((item, idx) => item.id));
    }
  },[isModalOpen])


  return (
    <Modal destroyOnClose title={<h3 className='border-b-2'>Sales Details</h3>} width={700} className='p-0 ' open={isModalOpen} footer={<></>} >
      <Form
        form={form}
        className='pt-2 mb-7' 
        labelAlign='left'
        labelCol={{span: 5}}
        initialValues={{ 
          from_date: dayjs(),
          to_date: dayjs(),
        }}
        autoComplete="off"
        variant='borderless'
      >
        <Form.Item label='From Date' name={'from_date'} className='font-bold mb-1' required>
          <DatePicker className='input-outline-none font-normal w-full' />
        </Form.Item>
        <Form.Item label='To Date' name={'to_date'} className='font-bold mb-1' required>
          <DatePicker className='input-outline-none font-normal w-full' />
        </Form.Item>
        <Form.Item label='POS' name={'pos'} className='font-bold mb-1' required>
          <Select mode='multiple' options={data.map(item => ({value: item.id, label: item.name}))} className='input-outline-none font-normal w-full' />
        </Form.Item>
        
      </Form>
      {/* <EditableTable 
          
          columns={[
            ...columns, 
            {
              title: 'Action', 
              // render: (_, record) => <Button type='text' icon={<MdDelete color='red' />} />
            }
          ]}
          pos={data}
          dataSource={pos}
          setDataSource={setPos}
          addLine={addLine}
        /> */}
      <div className='text-white'>
        <Button type='text' className='font-semibold text-white bg-[#189aa0] hover-btn' onClick={handlePrint} >PRINT</Button>
        <span className='mx-2'></span>
        <Button type='text' danger className='font-semibold text-[#189aa0] '  onClick={handleCancel}>CANCEL</Button>

      </div>
    </Modal>
  )
}

export default SalesDetailsModal;